module.exports = __webpack_public_path__ + "static/media/mac2.5a4c5a97.png";